'use strict';

import $ from 'jquery';
import { lib } from '../../common/Library';
import { ComparisonFyClass } from './comparison_fy';
import { Comparison4qClass } from './comparison_4q';
import { ComparisonIndexPerClass } from './comparison_index_per';
import { ComparisonIndexPbrClass } from './comparison_index_pbr';
import { ComparisonIndexDpsYClass } from './comparison_index_dps_y';
import { ComparisonIndexResDpsYClass } from './comparison_index_res_dps_y';
import { graphBoxesFy } from './graph_boxes_fy';
import { graphBoxes4q } from './graph_boxes_4q';
require('floatthead/dist/jquery.floatThead.min.js');

/**
 * グラフ生成制御
 */
$(function () {
    const fyChartUrl = $('#fyChartUrl').val();
    const q4ChartUrl = $('#q4ChartUrl').val();
    const indexChartUrl = $('#indexChartUrl').val();

    //通期グラフ
    if (fyChartUrl != null) {
        const zaimuFyList = JSON.parse($('#jsonZaimuFyList').val());
        const stockCdList = JSON.parse($('#jsonStockCdList').val());
        const stockNameList = JSON.parse($('#jsonStockNameList').val());

        $.each(stockCdList, function(idx, stockCd) {
            if (zaimuFyList[stockCd] != undefined && zaimuFyList[stockCd] > 0) {
                try {
                    $.ajax({
                        url: fyChartUrl + stockCd + '.json',
                        dataType: 'jsonp',
                        jsonpCallback: 'z_fy_all' + stockCd,
                    })
                    .done(function(json) {
                        try {
                            new ComparisonFyClass('#comparison_fy_' + stockCd, stockCd, stockNameList[stockCd], $.extend(true, {}, json['graph']['performance']), 5);
                        } catch(e) {
                            console.log(e);
                        }
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        console.log('status:' + textStatus);
                        console.log('response:' + jqXHR.responseText);
                    });
                } catch(e) {
                    console.log(e);
                }
            } else {
                dispNoData(stockCd, stockNameList[stockCd], '#comparison_fy_')
            }
        });

        // グラフボックス制御
        new graphBoxesFy;
    }

    //四半期グラフ
    if (q4ChartUrl != null) {
        const zaimu4qList = JSON.parse($('#jsonZaimu4qList').val());
        const stockCdList = JSON.parse($('#jsonStockCdList').val());
        const stockNameList = JSON.parse($('#jsonStockNameList').val());

        $.each(stockCdList, function(idx, stockCd) {
            if (zaimu4qList[stockCd] != undefined && zaimu4qList[stockCd] > 0) {
                try {
                    $.ajax({
                        url: q4ChartUrl + stockCd + '.json',
                        dataType: 'jsonp',
                        jsonpCallback: 'z_4q_all' + stockCd,
                    })
                    .done(function(json) {
                        try {
                            new Comparison4qClass('#comparison_4q_' + stockCd, stockCd, stockNameList[stockCd], $.extend(true, {}, json['graph']['performance']), 12);
                        } catch(e) {
                            console.log(e);
                        }
                    })
                    .fail(function(jqXHR, textStatus, errorThrown) {
                        console.log('status:' + textStatus);
                        console.log('response:' + jqXHR.responseText);
                    });
                } catch(e) {
                    console.log(e);
                }
            } else {
                dispNoData(stockCd, stockNameList[stockCd], '#comparison_4q_')
            }
        });

        // グラフボックス制御
        new graphBoxes4q;
    }

    //株価指標グラフ
    if (indexChartUrl != null) {
        const latestIndexList = JSON.parse($('#jsonLatestIndexList').val());
        const stockCdList = JSON.parse($('#jsonStockCdList').val());
        const stockNameList = JSON.parse($('#jsonStockNameList').val());

        if (stockCdList == null) {
            return;
        }

        let jsonList = []; //stockIndex JSONリスト
        let stockCdLength = stockCdList.length;

        $.each(stockCdList, function(idx, stockCd) {
            try {
                $.ajax({
                    url: indexChartUrl + stockCd + '.json',
                    dataType: 'jsonp',
                    jsonpCallback: 'stock_index' + stockCd,
                })
                .done(function(stockJson) {
                    try {
                        jsonList[stockCd] = stockJson;
                        if (Object.keys(jsonList).length === stockCdLength) {
                            new ComparisonIndexPerClass('comparison_index_per', $.extend(true, {}, jsonList), stockCdList, stockNameList, latestIndexList);
                            new ComparisonIndexPbrClass('comparison_index_pbr', $.extend(true, {}, jsonList), stockCdList, stockNameList, latestIndexList);
                            new ComparisonIndexDpsYClass('comparison_index_dps_y', $.extend(true, {}, jsonList), stockCdList, stockNameList, latestIndexList);
                            new ComparisonIndexResDpsYClass('comparison_index_res_dps_y', $.extend(true, {}, jsonList), stockCdList, stockNameList, latestIndexList);

                            setBalloonForGraph();
                        }
                    } catch(e) {
                        console.log(e);
                    }
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    console.log('status:' + textStatus);
                    console.log('response:' + jqXHR.responseText);
                });
            } catch(e) {
                console.log(e);
            }
        });
    }
});

/**
 * エラーメッセージ表示
 * @param {type} stockCd
 * @param {type} stockName
 * @param {type} divId
 * @returns {undefined}
 */
function dispNoData(stockCd, stockName, divId) {
    let html = '',
        url = $('#zaimuUrl').val();

    html += '<div class="no_data"><a href="' + url + '/' + stockCd + '">' + stockName + ' (' + stockCd + ')</a></div>';
    html += '<div class="no_data_msg">企業からの発表情報がありません。';

    $(divId + stockCd).html(html);
}

/**
 * 銘柄比較一覧制御
 */
$(function() {
    /**
     * cookie保持日数
     * @constant
     * @type Number
     */
    let COOKIE_EXPIRES = 365,

    /**
     * チェックリストcookie名
     * @constant
     * @type String
     */
        CHECKED_LIST = 'CHECKED_LIST',

    //チェックリストcookie値
        chkListCookieAry = [],

    /**
     * 銘柄リストcookie名
     * @constant
     * @type String
     */
        STOCK_LIST = 'STOCK_LIST',
    /**
     * 銘柄リストcookie値
     * @type String
     */
        stockCookieVal = '',
    /**
     * 比較銘柄一覧
     * @type Array
     */
        stockCookieList = [],

    /**
     * 項目表示順cookie名
     * @constant
     * @type String
     */
        TABLE_ORDER = 'TABLE_ORDER',

    //項目表示順cookie値
        orderCookieVal = '',
    //テーブルid配列
        tableOrderAry = [];

    /**
     * 初期表示処理
     */
    $(function() {
        let checkedIds,
            checkBoxIds,
            checkCookieVal = '',
            tableId,
            regEx,
            retIds,
            splitVal,
            existCookieFlg,
            $stockComparison = $('#stock_comparison');

        //全チェックボックス一覧を取得
        checkBoxIds = $('[name="chk"]').map(function() {
            return $(this).attr('id');
        });

        //cookieを取得する
        checkCookieVal = lib.myGetCookie(CHECKED_LIST);

        // cookie情報が存在しなかった時のフラグ
        if (checkCookieVal === null) {
            existCookieFlg = false; // 存在しない（初回表示）
        } else {
            existCookieFlg = true; // 存在する
        }

        let userAgent = window.navigator.userAgent.toLowerCase();
        //IE対応 cookie情報がないと、.lengthでエラーになるので空白を入れておく
        if (checkCookieVal === null || checkCookieVal === undefined || (checkCookieVal === ' ' && (userAgent.indexOf('msie') != -1 || userAgent.indexOf('trident') != -1))) {
            checkCookieVal = '';
        }

        // 初回表示以外でチェック項目がないとき、デフォルト表示項目をOFFにする
        if (existCookieFlg && checkCookieVal === '') {
            $('#comp_price').hide();
            $('#comp_price').removeClass('show');
            $('#comp_investor').hide();
            $('#comp_investor').removeClass('show');
            $('#chk_price').prop('checked', false);
            $('#chk_investor').prop('checked', false);
        }

        //cookie情報があれば、チェック状態を更新する
        if (checkCookieVal.length !== 0) {
            $.each(checkBoxIds, function(idx, id) {
                if (checkCookieVal.indexOf(id) !== -1) {
                    //cookieにあるidは表示
                    $('input[id="' + id + '"]').prop('checked', true);
                } else {
                    //cookieにないidは非表示
                    $('input[id="' + id + '"]').prop('checked', false);
                }
            });
        }

        //チェックボックスのchecked状態のものを取得
        checkedIds = $('[name="chk"]:checked').map(function() {
            return $(this).attr('id');
        });

        if (checkedIds !== undefined && checkedIds[0] !== undefined) {
            //チェック状態の項目を表示させる
            $.each(checkedIds, function(idx, id) {
                tableId = id.replace('chk', 'comp');
                //$('#' + tableId).show();
                $('#' + tableId).css('display', 'table-row-group');
                $('#' + tableId).addClass('show');

                //cookieをセットする(初期表示のものもここでcookieにセットする)
                chkListCookieAry.push(id);
            });
            //cookieセット
            lib.mySetCookie(CHECKED_LIST, chkListCookieAry.join('+'), COOKIE_EXPIRES);
        }

        //比較銘柄リストをcookieに保存する
        stockCookieVal = lib.getEncodeCookie(STOCK_LIST);
        if (stockCookieVal === undefined || stockCookieVal === null || stockCookieVal === '') {
            let favNameInputList = $("[id^='fav_name_']");
            if (favNameInputList !== null) {
                $.each(favNameInputList, function(idx, input) {
                    stockCookieList.push($(input).val());
                });
                stockCookieVal = stockCookieList.join('+');
                lib.setEncodeCookie(STOCK_LIST, stockCookieVal, COOKIE_EXPIRES);
            }
        }

        //テーブル(表示項目)の要素を取得
        orderCookieVal = lib.myGetCookie(TABLE_ORDER);
        //<tbody>のid一覧を取得
        if (orderCookieVal === undefined || orderCookieVal == null ||orderCookieVal == 'null' || orderCookieVal === '') {
            $stockComparison.find('tbody').map(function(idx) {
                orderCookieVal = orderCookieVal + idx + ':' + $(this).attr('id');
            });
        }

        //テーブル(表示項目)並び替え処理
        regEx = new RegExp('[0-9]*:[^0-9]*', 'g'); //ex) 0:表示項目要素名:1:表示項目要素名:・・・
        retIds = orderCookieVal.match(regEx);
        $.each(retIds.reverse(), function(idx, val) {
            splitVal = val.split(':');
            if (splitVal[1] !== undefined && splitVal[1] !== null) {
                tableOrderAry[splitVal[0]] = splitVal[1];
                $stockComparison.find('thead').after($('#'+splitVal[1]));
            }
        });

        //cookieに存在しないidがあるか調べる
        $stockComparison.find('tbody').map(function() {
            if (orderCookieVal.indexOf($(this).attr('id')) === -1) {
                //cookieの最後尾に追加
                orderCookieVal += tableOrderAry.length + ':' + $(this).attr('id');
                tableOrderAry[tableOrderAry.length] = $(this).attr('id');
            }
        });

        lib.mySetCookie(TABLE_ORDER, orderCookieVal, COOKIE_EXPIRES);

        //並び替えボタン無効化設定処理
        initOrderBtnStatus();

        //制限背景表示
        showLimitBg();
    });

    //表示項目選択checkbox
    $(document).on('click', '#display_table', function () {
        if ($('#disp_checkboxes').css('display') === 'none') {
            $('#disp_checkboxes').css('display', 'flex');
            $('.down').css('display', 'none');
            $('.up').css('display', 'inline');
        } else {
            $('#disp_checkboxes').hide();
            $('.down').css('display', 'inline');
            $('.up').css('display', 'none');
        }
    });

    // 別の部分が選択されたときに
    $(document).on('click', function (event) {
        if ($('#disp_checkboxes').css('display') !== 'none') {
            if (
                ! $(event.target).closest('#disp_checkboxes').length
                && ! $(event.target).closest('#display_table').length
            ) {
                $('#disp_checkboxes').hide();
                $('.down').css('display', 'inline');
                $('.up').css('display', 'none');
            }
        }
    });

    /**
     * チェックボックスが押された時の処理
     */
    $(function() {
        $('#disp_checkboxes :checkbox').on('change', function() {
            //Firefox,Edgeで業績予想の表示崩れを解消させる
            $(window).trigger('resize');

            //クリックされたチェックボックスのidを取得
            let checkedId = $(this).attr('id'),

            //表示/非表示させるテーブルidを生成 chk_price→comp_price
                tableId = checkedId.replace('chk', 'comp'),

            //クリックされたチェックボックスの状態を取得
                checked = $('#'+checkedId).prop('checked');

            //チェックボックスの状態で、テーブルの表示/非表示を切り替える
            if (checked) {
                $('#'+tableId).css('display', 'table-row-group');
                $('#'+tableId).addClass('show');
            } else {
                $('#'+tableId).hide();
                $('#'+tableId).removeClass('show');
            }

            //cookie
            if (checked) {
                //チェックが入れられた時 cookieセット
                chkListCookieAry.push(checkedId);
                lib.mySetCookie(CHECKED_LIST, chkListCookieAry.join('+'), COOKIE_EXPIRES);
            } else {
                //チェックが外された時 cookie破棄
                $.each(chkListCookieAry, function(idx, val) {
                    if (val === checkedId) {
                        chkListCookieAry.splice(idx, 1);
                        return false; //break
                    }
                });
                lib.mySetCookie(CHECKED_LIST, chkListCookieAry.join('+'), COOKIE_EXPIRES);
            }

            //並び替えボタン無効化設定
            initOrderBtnStatus();

            // 制限背景の高さを設定
            setLimitHeight();
        });
    });

    /**
     * テーブル順序入れ替え処理
     */
    $(function() {
        let parentTbodyId,
            thisOrderNo,
            changeTbody,
            nextTbodyId, //入れ替え先テーブルid
            nextOrderNo, //入れ替え先配列添え字
            tmpTableId;

        //▼ボタン
        $(document).on('click', '.data_item .down_btn', function () {
            //クリックされたボタンの親tbodyのidを取得
            parentTbodyId = $(this).closest('tbody.show').attr('id');

            if (parentTbodyId !== null) {
                //現在表示中の要素と入れ替える
                changeTbody = $('#'+parentTbodyId).nextAll('tbody.show')[0];
                $('#'+parentTbodyId).insertAfter(
                    $('#'+parentTbodyId).nextAll('tbody.show')[0]
                );

                //cookie処理
                //配列添え字を取得
                thisOrderNo = $.inArray(parentTbodyId, tableOrderAry);
                //入れ替え先がない場合、処理しない
                if (thisOrderNo < tableOrderAry.length - 1) {
                    //入れ替え先のテーブルidを取得
                    nextTbodyId = $(changeTbody).attr('id');
                    //入れ替え先の配列添え字を取得
                    nextOrderNo = $.inArray(nextTbodyId, tableOrderAry);
                    //上書き先のテーブルidを保持
                    tmpTableId = tableOrderAry[nextOrderNo];
                    //入れ替え
                    tableOrderAry[nextOrderNo] = parentTbodyId;
                    tableOrderAry[thisOrderNo] = tmpTableId;

                    //cookieセット
                    orderCookieVal = '';
                    $.each(tableOrderAry, function (idx, id) {
                        orderCookieVal = orderCookieVal + idx + ':' + id;
                    });

                    lib.mySetCookie(TABLE_ORDER, orderCookieVal, COOKIE_EXPIRES);
                }
            }

            //並び替えボタン無効化設定
            initOrderBtnStatus();
        });

        //▲ボタン
        $(document).on('click', '.data_item .up_btn', function () {
            //クリックされたボタンの親tbodyのidを取得
            parentTbodyId = $(this).closest('tbody.show').attr('id');

            //現在表示中の要素と入れ替える
            changeTbody = $('#' + parentTbodyId).prevAll('tbody.show')[0];
            $('#' + parentTbodyId).insertBefore(changeTbody);

            //cookie処理
            //配列添え字を取得
            thisOrderNo = $.inArray(parentTbodyId, tableOrderAry);
            //入れ替え先がない場合、処理しない
            if (thisOrderNo > 0) {
                //入れ替え先のテーブルidを取得
                nextTbodyId = $(changeTbody).attr('id');
                //入れ替え先の配列添え字を取得
                nextOrderNo = $.inArray(nextTbodyId, tableOrderAry);
                //上書き先のテーブルidを保持
                tmpTableId = tableOrderAry[nextOrderNo];
                //入れ替え
                tableOrderAry[nextOrderNo] = parentTbodyId;
                tableOrderAry[thisOrderNo] = tmpTableId;

                //cookieセット
                orderCookieVal = '';
                $.each(tableOrderAry, function (idx, id) {
                    orderCookieVal = orderCookieVal + idx + ':' + id;
                });
                lib.mySetCookie(TABLE_ORDER, orderCookieVal, COOKIE_EXPIRES);
            }

            //並び替えボタン無効化設定
            initOrderBtnStatus();
        });
    });

    /**
     * 表示テーブルの全選択
     */
    $(function() {
        let allTableNum = $('table.comp_table tbody').length,
            showTableNum = $('table.comp_table tbody.show').length,
            checkedId,
            tableId;

        if (showTableNum === allTableNum) {
            $('#table_all_mover').addClass('all_remove');
            $('#table_all_mover').removeClass('all_select');
            $('#table_all_mover').text('選択解除');
        }

        $(document).on('click', '#table_all_mover', function () {
            if ($(this).hasClass('all_select')) {
                $('li.table_select input:enabled').prop('checked', true);
                chkListCookieAry = [];
                $.each($('li.table_select input:enabled'), function (index, value) {
                    checkedId = $(this).attr('id');
                    tableId = checkedId.replace('chk', 'comp');

                    $('#' + tableId).css('display', 'table-row-group');
                    $('#' + tableId).addClass('show');

                    chkListCookieAry.push(checkedId);
                });

                //cookieセット
                lib.mySetCookie(CHECKED_LIST, chkListCookieAry.join('+'), COOKIE_EXPIRES);

                $(this).addClass('all_remove');
                $(this).removeClass('all_select');
                $(this).text('選択解除');
                initOrderBtnStatus();

            } else if ($(this).hasClass('all_remove')) {
                let $tableInput = $('li.table_select input');
                $tableInput.prop('checked', false);

                $.each($tableInput, function (index, value) {
                    checkedId = $(this).attr('id');
                    tableId = checkedId.replace('chk', 'comp');
                    $('#' + tableId).hide();
                    $('#' + tableId).removeClass('show');
                });

                //cookieセット
                lib.mySetCookie(CHECKED_LIST, '', COOKIE_EXPIRES);

                // checkIdリストをリセット
                chkListCookieAry = [];

                $(this).addClass('all_select');
                $(this).removeClass('all_remove');
                $(this).text('全選択');
            }

            // 制限背景の高さを設定
            setLimitHeight();
        })
    });

    /**
     * 列データ削除処理
     */
    $(function () {
        //×ボタンが押された時の処理
        //classにreloadがあればページリロードを行う
        $(document).on('click', '.remove_btn', function () {
            //cookieから削除
            delStockCodeCookie(this);

            //ページリロード
            location.reload();

            //新規追加された列にオートコンプリート設定を反映
            autoCompleteInit();
        });

        /**
         * 銘柄コードcookie削除
         * @param {object} _this
         */
        function delStockCodeCookie(_this) {
            //銘柄データ取得
            let compList = $('#stock_comparison').find('input[id^="fav_name_"]'),
                compVal,
                compCodeList = [],

            //クッキーに追加するデータ
            addCookieVal = null;

            // 削除対象の銘柄情報をinputから削除
            $(_this).parents('th.stock_col').find('input[id^="fav_name_"]').val('');

            // cookieを取得する
            stockCookieVal = lib.getEncodeCookie(STOCK_LIST);
            if (stockCookieVal !== undefined && stockCookieVal !== null && stockCookieVal !== '') {
                stockCookieList = stockCookieVal.split('+');
            }

            // 編集データ抽出
            $.each(compList, function(value) {
                if ($(compList[value]).val() !== '') {
                    compVal = $(compList[value]).val();
                    if (compVal === '上場廃止') {
                        compVal = '0000';
                    }
                    compCodeList.push(compVal);
                }
            });

            addCookieVal = compCodeList.join('+');

            if (addCookieVal !== stockCookieList.join('+')) {
                //変更があった場合にcookieセット
                lib.setEncodeCookie(STOCK_LIST, addCookieVal, COOKIE_EXPIRES);
            }
        }

        /**
         * リセットボタン押下時、項目並び順をリセットする
         */
        $(document).on('click', '#table_order_reset', function () {
            //cookie破棄
            lib.mySetCookie(TABLE_ORDER, '', 0);

            //ページリロード
            location.reload();
        });
    });

    /**
     * 銘柄をクリア
     */
    $(function() {
        $(document).on('click', '#regist_open', function () {
            if ($(this).attr('class') == 'inactive') {
                return;
            }

            // 確認ポップアップがすぐ閉じてしまう場合があるためsetTimeoutを挟んで回避
            setTimeout(function () {
                $.confirm({
                    title: '削除確認',
                    content: '現在入力されている銘柄を削除してよろしいですか？',
                    closeIcon: true,
                    type: 'orange',
                    boxWidth: '500px',
                    useBootstrap: false,
                    backgroundDismiss: true,
                    animation: 'top',
                    buttons: {
                        confirm: {
                            text: 'OK',
                            action: function() {
                                //cookie(STOCK_LIST)初期化
                                lib.setEncodeCookie(STOCK_LIST, null, COOKIE_EXPIRES);
                                //ページリロード
                                location.reload();
                            }
                        },
                        cancel: {
                            text: 'キャンセル'
                        }
                    }
                });
            },0);
        });
    });

    /**
     * 並び替えボタンの無効化を設定する
     */
    function initOrderBtnStatus() {
        let firstProcFlg = false,
            firstTbodyId, //最初に表示されているtbody id
            lastTbodyId; //最後に表示されているtbody id

        $('.comp_table tbody').each(function() {
            //表示中の最初と最後のtbody idを取得する
            if ($(this).css('display') !== 'none') {
                if (! firstProcFlg) {
                    firstTbodyId = '#' + $(this).attr('id');
                    firstProcFlg = true; //処理済み
                }
                lastTbodyId = '#' + $(this).attr('id');
            }

            //並び替えボタン無効化
            disabledUpBtn(firstTbodyId);
            disabledDownBtn(lastTbodyId);
        });
    }

    /**
     * 制限背景の高さを設定
     */
    function setLimitHeight() {
        $('#stock_comparison .comp_limit').innerHeight(
            $($('#stock_comparison .comp_table')[1]).outerHeight()
        );
    }

    /**
     * ▼ボタンの無効化
     * @param {string} tbodyId 無効化させるtbody id
     */
    function disabledDownBtn(tbodyId) {
        /**
         * 無効化状態を表すclass名
         * @constant
         * @type String
         */
        let DISABLED_CLASS = 'down_btn_disabled';

        //既存の無効化状態を解除
        $('a.' + DISABLED_CLASS).removeClass(DISABLED_CLASS);

        //新たに無効化状態設定
        $(tbodyId + ' a.down_btn').addClass(DISABLED_CLASS);
    }

    /**
     * ▲ボタンの無効化
     * @param {string} tbodyId 無効化させるtbody id
     */
    function disabledUpBtn(tbodyId) {
        /**
         * 無効化状態を表すclass名
         * @constant
         * @type String
         */
        let DISABLED_CLASS = 'up_btn_disabled';

        //既存の無効化状態を解除
        $('a.' + DISABLED_CLASS).removeClass(DISABLED_CLASS);

        //新たに無効化状態設定
        $(tbodyId + ' a.up_btn').addClass(DISABLED_CLASS);
    }

    /**
     * 制限背景を表示
     */
    function showLimitBg() {
        $('#stock_comparison .comp_limit').show();
    }

    /**
     * floatTheadの設定
     */
    $(function () {
        let ua = navigator.userAgent;

        if (ua.indexOf('iPhone') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
            // スマートフォン用コード
            $('tr.floatHead').remove();
        } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
            // タブレット用コード
            $('tr.floatHead').remove();
        } else {
            $('table.comp_table').floatThead({
                zIndex: 1,
            });
            $('tr.floatHead').remove();
        }

        // 制限背景の高さを設定(画面表示完了後)
        setTimeout(function() {
            setLimitHeight();
        }, 100);
    });

    //オートコンプリート機能の初期化
    autoCompleteInit();

    /**
     * オートコンプリート機能を初期化
     */
    function autoCompleteInit() {

        /**
         * 検索結果返却数リミット件数
         * @constant
         * @type Number
         */
        let RESULT_LIMIT = 10,
        /**
         * 検索除外フラグ COOKIE内にある銘柄は除外する
         * @constant
         * @type Number
         */
            EXCLUSION_FLG = 1,
        /**
         * 検索結果IPOフラグ
         * @constant
         * @type Number
         */
            IPO_FLG = 1,
        /**
         * 検索結果件数が0の時のメッセージ
         * @constant
         * @type String
         */
            NO_RESULT_MSG = '該当結果なし';

        $('.stock_name_input').autocomplete({
            source: function(request, response) {
                $.ajax({
                    url: $('#routeAjaxSuggest').val(),
                    type: 'POST',
                    cache: false,
                    dataType: 'json',
                    data: {
                        searchTerm: request.term,
                        resultLimit: RESULT_LIMIT,
                        exclusion: EXCLUSION_FLG,
                        ipoFlg: IPO_FLG
                    }
                })
                .done(function(ret) {
                    //検索結果件数が0の時

                    if (ret.length === 0) {
                        response([NO_RESULT_MSG]);
                        return;
                    }
                    response(ret);
                })
                .fail(function(jqXHR, textStatus, errorThrown) {
                    response(['']);
                });
            },
            autoFocus: true,
            delay: 200,
            minLength: 1,
            select: function(ev, ui) {
                // 銘柄コードを取得
                let searchVal = ui.item.value,
                    searchStockCd = searchVal.match(/\((.+)\)/)[1];

                //検索候補が無いとき、入力欄を削除
                if (searchVal === NO_RESULT_MSG) {
                    ui.item.value = '';
                    return;
                }

                if (searchVal !== null) {
                    //cookie取得
                    stockCookieVal = lib.getEncodeCookie(STOCK_LIST);

                    //cookie内に既に存在する銘柄か確認
                    if (stockCookieVal === null) {
                        //cookieが存在しない時
                        stockCookieVal = searchStockCd;
                        //cookieセット
                        lib.setEncodeCookie(STOCK_LIST, stockCookieVal, COOKIE_EXPIRES);
                        //ページリロード
                        location.reload();
                    } else if (stockCookieVal.indexOf(searchStockCd) === -1) {
                        //cookie内に検索銘柄が存在しない時
                        if (stockCookieVal.length === 0) {
                            stockCookieVal = searchStockCd;
                        } else {
                            stockCookieVal = stockCookieVal + '+' + searchStockCd;
                        }
                        //cookieセット
                        lib.setEncodeCookie(STOCK_LIST, stockCookieVal, COOKIE_EXPIRES);
                        //ページリロード
                        location.reload();
                    } else {
                        //cookie内に検索銘柄が存在する時、アラートを表示
                        lib.jqAlert(
                            '比較銘柄重複エラー',
                            searchVal + ' はすでに比較対象に指定されています<br>'
                        );
                        //入力欄初期化
                        ui.item.value = '';
                        return;
                    }
                }
            }
        });
    }
});
